export default __webpack_public_path__ + "media/images/brands/portmeirion-25e2fb894485db6a51c5cef63da7eaee.png";